export default __webpack_public_path__ + "static/media/wetsuit.846747fd.png";